module.exports = __webpack_public_path__ + "img/a1.f1f1d3bc.png";